import { httpRequest } from "@services/http";

export interface UserPermissionFeature {
  name: string;
  level: number;
  path: string[];
}

export interface UserPermissions {
  features: UserPermissionFeature[];
  organizations: { id: number; name: string; parent_id: number | null }[];
}

export class CommandGetUserPermissions {
  async run(userId: number): Promise<UserPermissions> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/users/${userId}/permissions/`;
    try {
      return await httpRequest<UserPermissions>(url, { method: "GET" });
    } catch (error) {
      console.error("Error fetching user permissions:", error);
      throw error;
    }
  }
}
